import axios from "axios";
import { API } from "@/lib/api";
import { trackSession } from "@/lib/session";

// Applicants have their own token, kept apart from the staff session in api.js.
export const APPLICANT_TOKEN_KEY = "penda_applicant_token";

const applicantApi = axios.create({ baseURL: API });

applicantApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(APPLICANT_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const APPLICANT_SESSION_EXPIRED = "penda:applicant-session-expired";
trackSession(applicantApi, APPLICANT_TOKEN_KEY, () => window.dispatchEvent(new Event(APPLICANT_SESSION_EXPIRED)));

export const getApplicantToken = () => localStorage.getItem(APPLICANT_TOKEN_KEY);
export const setApplicantToken = (t) => localStorage.setItem(APPLICANT_TOKEN_KEY, t);
export const clearApplicantToken = () => localStorage.removeItem(APPLICANT_TOKEN_KEY);

export default applicantApi;
